<script lang="ts">
  import Icon from './Icon.svelte';
  import { t } from '../i18n/index.svelte';
  import type { DimMode } from '../core/DimensionTool';

  let {
    mode,
    showTotal,
    status,
    onMode,
    onToggleTotal,
    onClear,
    onClose,
  }: {
    mode: DimMode;
    showTotal: boolean;
    status: string;
    onMode: (m: DimMode) => void;
    onToggleTotal: () => void;
    onClear: () => void;
    onClose: () => void;
  } = $props();
</script>

<div class="measure-bar">
  <div class="row">
    <span class="head"><Icon name="measure" size={16} /> {t('measure.title')}</span>
    <button class="close" title={t('common.close')} aria-label={t('common.close')} onclick={onClose}>
      <Icon name="close" size={16} />
    </button>
  </div>

  <div class="opts">
    <button class:active={showTotal} onclick={onToggleTotal}>{t('measure.total')}</button>
    <button class:active={mode === 'inner'} onclick={() => onMode(mode === 'inner' ? 'off' : 'inner')}>
      {t('measure.inner')}
    </button>
    <button class:active={mode === 'manual'} onclick={() => onMode(mode === 'manual' ? 'off' : 'manual')}>
      {t('measure.manual')}
    </button>
    <button class="clear" onclick={onClear}>{t('measure.clear')}</button>
  </div>

  {#if status}
    <p class="status">{status}</p>
  {:else if mode === 'manual'}
    <p class="status">{t('measure.manualHint')}</p>
  {/if}
</div>

<style>
  .measure-bar {
    position: absolute;
    right: var(--space-md);
    bottom: 84px;
    z-index: var(--z-panel);
    width: 240px;
    padding: var(--space-sm) var(--space-md);
    background: var(--color-surface-glass);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-control);
    box-shadow: var(--shadow-panel);
    backdrop-filter: blur(10px);
  }
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space-xs);
  }
  .head {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    color: var(--color-text-primary);
  }
  .close {
    border: none;
    background: transparent;
    color: var(--color-text-secondary);
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
  }
  .close:hover {
    color: var(--color-error);
  }
  .opts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }
  .opts button {
    min-height: 36px;
    border: 1px solid var(--color-border);
    border-radius: var(--radius-control);
    background: var(--color-surface);
    color: var(--color-text-primary);
    font: inherit;
    font-weight: 600;
    cursor: pointer;
  }
  .opts button:hover {
    border-color: var(--color-primary);
    color: var(--color-primary);
  }
  .opts button.active {
    background: var(--color-primary);
    border-color: var(--color-primary);
    color: #fff;
  }
  .opts .clear {
    color: var(--color-text-secondary);
  }
  .opts .clear:hover {
    border-color: var(--color-error);
    color: var(--color-error);
  }
  .status {
    margin: var(--space-xs) 0 0;
    font-size: var(--font-size-caption);
    color: var(--color-text-secondary);
    line-height: 1.4;
  }

  @media (max-width: 767px) {
    .measure-bar {
      right: var(--space-md);
      left: var(--space-md);
      width: auto;
      bottom: 140px;
    }
  }
</style>
